import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@cashew/button';
import ConfirmModal from '@cashew/confirm-modal';

export default ({
  showConfirmModal,
  setShowConfirmModal,
  actionLoading,
  actionFunction,
}: any) => {
  const { t } = useTranslation();
  const ns = 'customers-details';
  return (
    <ConfirmModal
      isVisible={showConfirmModal}
      onClose={() => {
        setShowConfirmModal(false);
      }}
      showCloseButton={false}
      confirmTitle={t('customerDetails.resetPopup.title')}
      confirmDescription={t('customerDetails.resetPopup.subTitle')}
      confirmButtons={
        <div className={`${ns}__reset-popup-buttons`}>
          <Button
            extraClass={`${ns}__reject-button`}
            onClick={() => {
              setShowConfirmModal(false);
            }}
          >
            {t('customerDetails.resetPopup.rejectButton')}
          </Button>
          <Button
            extraClass={`${ns}__success-button`}
            disabled={actionLoading}
            onClick={actionFunction}
            loading={actionLoading}
          >
            {t('customerDetails.resetPopup.successButton')}
          </Button>
        </div>
      }
      resultTitle=""
      resultDescription=""
      resultButtons={<></>}
      showResult={false}
      resultStatus="none"
    />
  );
};
